import React from "react";
import { IoArrowBackSharp } from "react-icons/io5";

function PropertyListingHeader({ backLabel, title, subtitle }) {
  const backPage = () => {
    window.history.back();
  };

  return (
    <div className="listing-header">
      <button
        type="button"
        className="listing-header__back"
        onClick={backPage}
        aria-label="Voltar"
      >
        <IoArrowBackSharp />
        <span>{backLabel}</span>
      </button>
      <h1 className="listing-header__title">{title}</h1>
      {subtitle && <p className="listing-header__subtitle">{subtitle}</p>}
    </div>
  );
}

export default PropertyListingHeader;
